import { useMutation } from '@tanstack/react-query';

import { testSendContactPoint } from './testSendContactPoint';
import { type TestSendContactPointMutationOptions } from './types';

/**
 * Custom hook for sending a test request to a contact point's receiver
 *
 * @param options - Additional options for the useMutation hook.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Subscription
 */
export const useMutationTestSendContactPoint = (
  options?: TestSendContactPointMutationOptions,
) =>
  useMutation({
    mutationFn: testSendContactPoint,
    ...options,
  });
